import React from 'react';
import { Button, SvgIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { typography, spaces, palette } from '../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../utils/getMuiIcon';

interface ReadMoreButtonProps {
  onClick: () => void;
  variant?: 'tertiary' | 'primary';
  fullWidth?: boolean;
}

const tertiaryButtonStyles = {
  ...typography.button.small,
  color: palette.primary.main,
  padding: `${spaces.xxs} ${spaces.xs}`,
  textTransform: 'none',
  '&:hover': {
    backgroundColor: 'transparent',
  },
};

const primaryButtonStyles = {
  ...typography.button.small,
  padding: `${spaces.xxs} ${spaces.xs}`,
  justifyContent: 'space-between',
};

const iconStyles = {
  width: 18,
  height: 18,
};

const ReadMoreButton: React.FC<ReadMoreButtonProps> = ({
  onClick,
  variant = 'primary',
  fullWidth = false,
}) => {
  const { t } = useTranslation();

  const buttonStyles = variant === 'tertiary' ? tertiaryButtonStyles : primaryButtonStyles;

  return (
    <Button
      variant='text'
      color={variant === 'primary' ? 'primary' : undefined}
      fullWidth={fullWidth}
      onClick={onClick}
      sx={buttonStyles}
      endIcon={
        <SvgIcon
          sx={iconStyles}
          viewBox='0 0 18 18'
          component={getMuiIcon('arrowRightLong')}
        />
      }
    >
      {t('Read more about AI assistant')}
    </Button>
  );
};

export default ReadMoreButton;

